// extracted by mini-css-extract-plugin
export default {"Container":"TabBar_Container__lpAgi"};